import React, { useState, useEffect } from "react";
import GridContainer from "@jumbo/components/GridContainer";
import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Paper, Select } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux"
import { Create } from "@material-ui/icons";
import { useParams } from "react-router";
import { makeStyles } from "@material-ui/core/styles";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import DateRangeIcon from "@material-ui/icons/DateRange";
import moment from "jalali-moment";
import TicketRequests from "services/tickets";
import { baseUrl } from "@jumbo/constants/baseUrl";

const useStyles = makeStyles((theme) => ({
    formControl: {
        width: "100%",
        maxWidth: '300px'
    },
    formTitleContainer: {
        padding: "1rem",
        fontWeight: "bold",
        fontSize: "17px",
        color: theme.palette.primary.main,
    },
    Title: {
        padding: "0.8rem",
        backgroundColor: theme.palette.grey[200],
        fontWeight: "bold",
    },
    userInput: {
        padding: "0.8rem",
        fontWeight: "bold",
        minHeight: "45.61px",
    },
}));

const TicketDetailsContainer = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const { ticket } = useSelector(({ tickets }) => tickets);
    const { id } = useParams();
    const [answerStatus, setAnswerStatus] = useState('');

    useEffect(() => {
        dispatch(TicketRequests.getTicketById(id));
    }, [id, dispatch]);

    useEffect(() => {
        if (ticket) {
            setAnswerStatus(ticket.status)
        }
    }, [ticket])

    const handleUpdateStatus = () => {
        dispatch(TicketRequests.updateTicketStatus(id, answerStatus))
    }

    return (
        <GridContainer>
            <Grid item md={8} xs={12}>
                <Paper>
                    <Box className={classes.formTitleContainer}>
                        {ticket?.subject}
                    </Box>
                    <Box className={classes.Title}>پیام</Box>
                    <Box className={classes.userInput}>{ticket?.message}</Box>
                    <Box className={classes.Title}>نام ارسال کننده</Box>
                    <Box className={classes.userInput}>{ticket?.guest?.fullName}</Box>
                    <Box className={classes.Title}>کد ملی ارسال کننده</Box>
                    <Box className={classes.userInput}>{ticket?.guest?.codeMeli}</Box>
                    <Box className={classes.Title}>کد پرسنلی ارسال کننده</Box>
                    <Box className={classes.userInput}>{ticket?.guest?.codePersoneli}</Box>
                    <Box className={classes.Title}>تصویر </Box>
                    <Box className={classes.userInput}>
                        <img src={`${baseUrl}file/get/${ticket?.guest?.picPersoneli}`} />
                    </Box>

                </Paper>
            </Grid>
            <Grid item md={4} xs={12}>
                <Paper elevation={3}>
                    <Box className={classes.formTitleContainer}>جزئیات تیکت</Box>
                    <Box className={classes.Title}>
                        <Box display={"flex"} alignItems={"center"}>
                            <VpnKeyIcon style={{ marginLeft: "5px" }} />
                            شناسه :
                        </Box>
                    </Box>
                    <Box className={classes.userInput} textAlign={"right"}>
                        {ticket?._id}
                    </Box>
                    <Box className={classes.Title}>
                        <Box display={"flex"} alignItems={"center"}>
                            <DateRangeIcon style={{ marginLeft: "5px" }} />
                            تاریخ ارسال :
                        </Box>
                    </Box>
                    <Box className={classes.userInput} textAlign={"right"}>
                        {ticket
                            ? moment(ticket.createdAt)
                                .locale("fa")
                                .format("HH:mm:ss  YYYY/MM/DD ")
                            : null}
                    </Box>
                    <Box className={classes.Title}>
                        <Box display={"flex"} alignItems={"center"}>
                            <DateRangeIcon style={{ marginLeft: "5px" }} />
                            تاریخ به‌روز‌رسانی :
                        </Box>
                    </Box>
                    <Box className={classes.userInput} textAlign={"right"}>
                        {ticket
                            ? moment(ticket.updatedAt)
                                .locale("fa")
                                .format("HH:mm:ss  YYYY/MM/DD ")
                            : null}
                    </Box>

                    <Box className={classes.Title}>وضعیت </Box>
                    <Box className={classes.userInput}>
                        <Box >
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel id="demo-simple-select-outlined-label">
                                    وضعیت
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-outlined-label"
                                    id="demo-simple-select-outlined"
                                    value={answerStatus}
                                    onChange={(e) => setAnswerStatus(e.target.value)}
                                    label="نوع کاربر"
                                >
                                    <MenuItem value={"WaitingForResponse"}>منتظر پاسخ گویی</MenuItem>
                                    <MenuItem value={"Responded"}>پاسخ داده شده</MenuItem>
                                </Select>
                            </FormControl>
                            <Box display={"flex"} justifyContent={"end"} marginTop={"10px"} >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="medium"
                                    startIcon={<Create />}
                                    onClick={handleUpdateStatus}
                                >
                                    ویرایش
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Paper>
            </Grid>
        </GridContainer>
    );
};

export default TicketDetailsContainer;